import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CinemaFinder from '../views/CinemaFinder.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/old',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'CinemaFinder',
    component: CinemaFinder
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
